<template>
  <es-dialog :visible.sync="visible" :title="$t('选择收货地址')" width="658px" border :before-close="close" custom-class="address-select-dialog">
    <div class="address-content">
      <es-radio-group v-model="choosedAdd" style="width: 100%" v-if="addresses.length > 0">
        <div :class="['address-card', { defaultAdd: item.defaultFlag }]" v-for="(item, index) in addresses" :key="index">
          <es-radio :label="item.addressId">
            <div class="address">{{ item.addressAll }}</div>
            <div class="name-phone">
              <div class="name">{{ item.contact }}</div>
              <div class="phone">{{ item.contactNumber }}</div>
            </div>
          </es-radio>
        </div>
      </es-radio-group>
    </div>
    <div slot="footer" class="footer">
      <es-button variant="text" theme="primary" size="large" @click="addAddress">{{ $t('新建地址') }}</es-button>
      <div class="confirm-cancel">
        <es-button variant="outline" @click="close">{{ $t('取消') }}</es-button>
        <es-button type="primary" @click="onSubmit">{{ $t('确定') }}</es-button>
      </div>
    </div>
  </es-dialog>
</template>
<script>
export default {
  name: 'AddressSelectDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    addresses: {
      type: Array,
      default: () => [],
    },
    defaultChoosedAdd: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      choosedAdd: '',
    }
  },
  watch: {
    defaultChoosedAdd: {
      handler(newVal) {
        this.choosedAdd = newVal
      },
      immediate: true,
    },
  },
  methods: {
    close() {
      this.$emit('close', false)
    },
    onSubmit() {
      this.$emit('submit', this.choosedAdd)
    },
    addAddress() {
      this.close()
      this.$emit('addAddress')
    },
  },
}
</script>

<style lang="less" scoped>
.address-content {
  max-height: 230px;
  overflow-y: auto;
}
.address-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 13px 20px;
  border: 1px solid #e5e6eb;
  border-radius: 8px;
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
  /deep/ .es-radio {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row-reverse;
  }
  .address {
    font-weight: 500;
    font-size: 12px;
    line-height: 17px;
    color: #333333;
    margin-bottom: 8px;
  }
  .name-phone {
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    color: #999999;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .name {
      margin-right: 4px;
    }
  }
}
.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.address-select-dialog {
  /deep/ .es-es-dialog__footer {
    padding: 16px 24px;
  }
}
</style>
